import { render, staticRenderFns } from "./fileItem.vue?vue&type=template&id=65b26bdc&"
import script from "./fileItem.vue?vue&type=script&lang=js&"
export * from "./fileItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports